'use strict';

var React = require('react');

var SvgVocabularyMajor = function SvgVocabularyMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20 1.5a1.5 1.5 0 0 0-1.5-1.5h-6.5c-.768 0-1.469.29-2 .766a2.987 2.987 0 0 0-2-.766h-6.5a1.5 1.5 0 0 0-1.5 1.5v15a1.5 1.5 0 0 0 1.5 1.5h6.5a1 1 0 0 1 1 1 1 1 0 1 0 2 0 1 1 0 0 1 1-1h6.5a1.5 1.5 0 0 0 1.5-1.5v-15zm-2 14.5h-6c-.352 0-.687.067-1 .179v-13.179a1 1 0 0 1 1-1h6v14zm-10 0h-6v-14h6a1 1 0 0 1 1 1v13.179a2.959 2.959 0 0 0-1-.179z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 4h3v2h-3zm9 0h3v2h-3zm-9 4h3v2h-3zm9 0h3v2h-3zm-9 4h3v2h-3z"
  }));
};

exports.SvgVocabularyMajor = SvgVocabularyMajor;
